import {utils} from '@wallaby-ui/core';

import {
  FILTER_AND_SEARCH_REDUCER_REPORTS_STATE_ID,
  FILTERING_REDUCER_REPORTS_STATE_ID,
  REPORTS_REDUCER_STATE_ID,
} from './reports_constants';
import {reportsSlice} from './reports_slice';
import {filterAndSearchSlice} from 'src/js/containers/filter_and_search';
import {reducer as filtering} from 'src/js/containers/filtering';

export const getReducers = (key: string) => ({
  [utils.reducerUtils.getInstanceReducerId(REPORTS_REDUCER_STATE_ID, key)]:
    utils.reducerUtils.createFilteredReducer(reportsSlice.reducer, (action) => {
      const stateId = action.stateId ?? action.meta?.stateId;
      return (
        stateId ===
        utils.reducerUtils.getInstanceReducerId(REPORTS_REDUCER_STATE_ID, key)
      );
    }),
  [utils.reducerUtils.getInstanceReducerId(
    FILTER_AND_SEARCH_REDUCER_REPORTS_STATE_ID,
    key
  )]: utils.reducerUtils.createFilteredReducer(
    filterAndSearchSlice.reducer,
    (action) => {
      const stateId = action.stateId ?? action.meta?.stateId;
      return (
        stateId ===
        utils.reducerUtils.getInstanceReducerId(
          FILTER_AND_SEARCH_REDUCER_REPORTS_STATE_ID,
          key
        )
      );
    }
  ),
  [utils.reducerUtils.getInstanceReducerId(
    FILTERING_REDUCER_REPORTS_STATE_ID,
    key
  )]: utils.reducerUtils.createFilteredReducer(filtering, (action) => {
    const stateId = action.stateId ?? action.meta?.stateId;
    return (
      stateId ===
      utils.reducerUtils.getInstanceReducerId(
        FILTERING_REDUCER_REPORTS_STATE_ID,
        key
      )
    );
  }),
});
